import React from "react";
import Book from "../Book/Book";
import { getFirstBooks } from "../../services/Book";
import Slider from "react-slick";
import "./NewBooks.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as LoaderActions } from "../../store/ducks/loader";
import { Creators as BooksActions } from "../../store/ducks/books";

class NewBooks extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      booksReleases: [],
      booksHighlights: [],
      launch: true
    };
    this.handleClickPushAllBooks = this.handleClickPushAllBooks.bind(this);
  }

  sleep(time) {
    return new Promise(res => setTimeout(res, time));
  }

  async componentDidMount() {
    let { isLoading } = this.props;
    let { books: booksState } = this.props.books;

    let booksHighlights = "";
    let booksReleases = "";
    let books = [];
    isLoading(true);

    if (booksState.length === 0) {
      try {
        let { data } = await getFirstBooks();
        books = data;
        books = books.map(book => {
          book.price = book.price.toFixed(2).replace(".", ",");
          return book;
        });
      } catch (Error) {
        alert("Aconteceu um erro!");
      }

      booksHighlights = books.filter(book => book.typeBook === "Destaque");
      booksReleases = books.filter(book => book.typeBook === "Lançamento");
      await this.setState({ booksHighlights, booksReleases });
      await this.sleep(3000);
      isLoading(false);
      this.props.addBooks(books);
    } else {
      booksHighlights = booksState.filter(book => book.typeBook === "Destaque");
      booksReleases = booksState.filter(book => book.typeBook === "Lançamento");
      await this.setState({ booksHighlights, booksReleases });
      await isLoading(false);
    }
  }

  handleClickPushAllBooks() {
    const { history } = this.props;
    history.push("/Loja");
  }

  render() {
    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      speed: 200,
      arrows: true,
      dotsClass: "card-dots",
      autoplaySpeed: 905000,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        }
      ]
    };

    return (
      <div className="newBooks container" id="newBooks">
        <div className="newBooks__header">
          <div className="newBooks__header__titles">
            <h3 className="newBooks__header__title">LIVROS </h3>
            <span className="newBooks__header__arrow"> > </span>
            <h4
              className={`newBooks__header__types  ${
                this.state.launch ? "color-second" : "color-terc"
              }`}
              onClick={() => this.setState({ launch: true })}
            >
              LANÇAMENTOS
            </h4>
            <h4
              className={`newBooks__header__types ${
                this.state.launch ? "color-terc" : "color-second"
              }`}
              onClick={() => this.setState({ launch: false })}
            >
              DESTAQUES
            </h4>
          </div>
          <div className="newBooks__header__allbokscontent">
            <button
              style={{ alignSelf: "flex-end" }}
              className="newBooks__header__allBooks"
              onClick={this.handleClickPushAllBooks}
            >
              VER TODOS
            </button>
          </div>
        </div>

        <div className="newbooks-books">
          {this.state.launch ? (
            <Slider className="" {...settings}>
              {this.state.booksReleases.map(book => (
                  <Book key={book._id} data={book} history={this.props.history} />
              ))}
            </Slider>
          ) : (
            <Slider style={{ padding: 0 }} className="" {...settings}>
              {this.state.booksHighlights.map(book => (
                <Book key={book._id}  history={this.props.history} data={book} />
              ))}
            </Slider>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    Object.assign({}, LoaderActions, BooksActions),
    dispatch
  );
};

const mapStateToProps = state => ({
  books: state.books
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBooks);



// WEBPACK FOOTER //
// ./src/components/NewBooks/NewBooks.js